import React, { useEffect, useState } from "react";
import { Row, Carousel, Button, Container, ProgressBar } from "react-bootstrap";
import axios from "axios";
import "./popup.css";
import api from '../../seller-apis/api';
import { variables } from "../../Variables.json";
import { useAlert } from "react-alert";
import convertFileToWebP from "../../utilities/convertFileToWebP";
import { GenUtilities } from "../../utilities/GenUtilities";

// Images related
var imagesName = [];
var s3Urls = [];
var imgUrls = [];
// var backeyactive = false;

// Videos related
var videosName = [];
var vids3Urls = [];
var currentLink;

function PopupProductReport(props) {
  const alert = useAlert();
  const [vendorId, setvendorId] = useState(localStorage.getItem("vendorId"));
  const [reportType, setReportType] = useState([]);
  const [isReportAlready, setIsReportAlready] = useState(false);
  const [reportData, setReportData] = useState(false);

  // Images Related
  const [urlList, seturlList] = useState([]);
  const [description, setdescription] = useState("");
  const [sDescription, setSDescription] = useState("");
  const [image1, setimage1] = useState("");
  const [image2, setimage2] = useState("");
  const [urlListshow, seturlListshow] = useState(false);
  const [imgprogress, setimgprogress] = useState();
  const [imgLabelDisable, setimgLabelDisable] = useState(false);

  // Videos related
  const [vidurlList, setvidurlList] = useState([]);
  const [vidurlListshow, setvidurlListshow] = useState(false);
  const [progress, setProgress] = useState();
  const [videoShow, setvideoShow] = useState("none");
  const [multipleIssue, setMultipleIssue] = useState([1]);
  const [show, setShow] = useState(false);


  // Show Image

  async function showImage(event, spcl) {
    let comImg;
    let imageFinal;
    let registerImage;
    let isimgsSizevalid = true;
    let limit = event.target.files.length;
    for (let i = 0; i < limit; i++) {
        if (event.target.files[i].size > variables.limit.Newproductupload.image) {
        isimgsSizevalid = false;
        }
    }
    if (isimgsSizevalid) {
        setimgLabelDisable(true);
        seturlListshow(false);
        for (let i = 0; i < limit; i++) {
        var str = event.target.files[i].name;
        
        let convertedImg= await convertFileToWebP(event.target.files[0]);
        // console.log(convertedImg);
        // return false
        comImg = convertedImg.name.replace(/[^\w]/g, "");
        let extension = convertedImg.name.slice(
            event.target.files[i].name.lastIndexOf(".")
        );
        imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + comImg + extension);
        registerImage = convertedImg;
        if (spcl === "cov") {
            imagesName.unshift(imageFinal);
        } else {
            imagesName.push(imageFinal);
        }
        switch (spcl) {
            case "1":
            setimage1(imageFinal);
            break;
            case "2":
            setimage2(imageFinal);
            break;
        }
        var data = {
            imageName: imageFinal,
            type: "products",
        };
        api.product
            .saveProductImage(data)
            .then((res) => {
            axios({
                method: "put",
                url: res.data,
                data: registerImage,
                onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                setimgprogress(Math.round((100 * data.loaded) / data.total));
                },
            })
                .then((response) => {
                setimgprogress();
                setimgLabelDisable(false);
                seturlList(imagesName);
                seturlListshow(true);
                })
                .then((response) => {
                setimgprogress();
                setimgLabelDisable(false);
                seturlList(imagesName);
                seturlListshow(true);
                })
                .catch((error) => {
                console.log(error);
                });
            })
            .catch((err) => console.log(err));
        s3Urls.push(imageFinal);
        }
    } else {
        alert.info("Please upload image of size less than or equal to 500 kb");
    }
}

// Show Video

function showVideo(event) {
    setvidurlListshow(false);
    let comImg;
    let imageFinal;
    let registerImage;
    let videoSize = 0;
    if (event.target.files.length > 1 || vidurlList.length === 1) {
        alert.info("A max of 1 video can be uploaded");
        setvidurlListshow(true);
    }
    if (event.target.files.length > 0) {
        for (let i = 0; i < 1; i++) {
        videoSize = videoSize + event.target.files[i].size;
        }
        if (videoSize <= variables.limit.Newproductupload.video) {
        for (let i = 0; i < 1; i++) {
            var str = event.target.files[i].name;
            let extension = event.target.files[i].name.slice(
            event.target.files[i].name.lastIndexOf(".")
            );
            comImg = str.replace(/[^\w]/g, "");
            imageFinal = GenUtilities.removeSpacesFromName("vid_" + vendorId + "_" + comImg + extension);
            registerImage = event.target.files[0];
            var data = {
            imageName: imageFinal,
            type: "products",
            bucket: "m",
            };
            imageFinal = "products/" + imageFinal
            videosName.push(imageFinal);
            api.product
            .saveProductImage(data)
            .then((res) => {
                axios({
                method: "put",
                url: res.data,
                data: registerImage,
                onUploadProgress: (data) => {
                    setProgress(Math.round((100 * data.loaded) / data.total));
                },
                })
                .then((response) => {
                    setProgress();

                    setvidurlList(videosName);
                    setvidurlListshow(true);
                })
                .then((response) => {
                    setProgress();

                    setvidurlList(videosName);
                    setvidurlListshow(true);
                })
                .catch((error) => {
                    console.log(error);
                });
            })
            .catch((err) => console.log(err));
            vids3Urls.push(imageFinal);
        }
        } else {
        alert.info("A max size of 15 Mb video can be uploaded");
        }
    }
  }

  // play video
  function playVideo(vidId) {
    currentLink = vidId;
    setvideoShow("block");
    document.getElementById("cntn").classList.add("div-bk");
  }

  // Hide player
  function hidePlayer() {
    document.getElementById("vidPlayer").pause();
    document.getElementById("cntn").classList.remove("div-bk");
    setvideoShow("none");
  }
useEffect(() =>{
    if(!reportType.includes('image')){
        imagesName=[];
        setimage1("");
        setimage2("");
    }
    if(!reportType.includes('video')){
        imagesName=[];
        setimage1("");
        setimage2("");
    }
    if(!reportType.includes('video')){
        videosName=[];
        setvidurlListshow(false);
        setvidurlList([]);
        
    }
},[reportType.includes("image"),reportType.includes('shortDescription'),reportType.includes('video')])
  function checkProductReport(val,index) {
    
    setIsReportAlready(false);
    if(reportType.length <= index+1) {
        let rt=reportType;
        rt[index]=val;
        setReportType([...rt]);
    }
    else{
    setReportType(prevVal => [...prevVal,val]);
    }
    let productReportData = {
        filter: { "product-objectId": props.pid,
                  "reportType-id": val,
                  "status-id": "PENDING" }
    };

    api.product
    .sellerProductsEditReqRetrieveAll(productReportData)
    .then((res) => {
        // console.log(res);
        if (res.data.length > 0) {
            let date = new Date(res.data[0].updatedAt);
            let d = date.toUTCString(res.data[0].updatedAt);
            res.data[0].newd = d.substr(4, 12);
            setReportData(res.data[0]);
            setIsReportAlready(true);
        }
    })
    .catch((err) => {
        console.log(err);
        // alert.error("Failed to save");
    });
  }

  function AddProductReport() {
    if (!reportType.length) {
        alert.info("Please select report type");
    } else if (reportType.includes('longDescription') && !description) {
        alert.info("Please fill description");
    }
    else if (reportType.includes('shortDescription') && !sDescription) {
            alert.info("Please fill description");
    }
     else if (reportType.includes('image') && imagesName.length > 2) {
        alert.info("Max. of 2 images is allowed");
    } else if (reportType.includes('image') && imagesName.length < 1) {
        alert.info("Image is required");
    } else if (reportType.includes('video') && vidurlList.length > 1) {
        alert.info("Max. of 1 video is allowed");
    } else if (reportType.includes('video') && vidurlList.length < 1) {
        alert.info("Video is required");
    } else {
        imgUrls=[];
        for (let i = 0; i < imagesName.length; i++) {
            let data = {
            baseImage: false,
            smallImage: false,
            thumbnail: false,
            visible: false,
            image: "products/" + imagesName[i],
            label: imagesName[i],
            };
            imgUrls.push(data);
        }

        let productReportData;
        let videoLink;
        if (videosName.length > 0) {
            videoLink = videosName;
        }
        let combination={};
        if(props?.product?.combination[0]?.value[0]){
            combination['keys']=props?.product?.combination[0]?.value;
            let tempData=[];
            props?.product?.attributeList.forEach(element => {
                tempData.push(element.selectedValue);
            });
            combination['values']=tempData;
              
        }
        
        productReportData = {
            product: props.pid,
            images: imgUrls,
            description: description,
            shortDescription:sDescription,
            combination:combination,
            videos: videoLink,
            reportType: reportType,
            status: "PENDING",
            categories: props.categories
        };

        console.log("productReportData: ", productReportData);
        // return;
        
        api.product
        .saveSellerProductsEditReq(productReportData)
        .then((res) => {
            setShow(true);
            // props.popupVisibility();
        })
        .catch((err) => {
            console.log(err);
            alert.error("Failed to save");
        });
    }

  }
  function deleteImg(spcl, ele) {
    // seturlListshow(false)
    
    seturlList([]);
    imagesName.splice(spcl-1, 1);
    switch (spcl) {
      case 0:
        // setimagecov("");
        break;
      case 1:
        setimage1("");
        break;
      case 2:
        setimage2("");
        break;
    }
    let eleLoader = document.getElementById(ele);
    seturlList(imagesName);
    eleLoader.setAttribute("class", "spinner-border text-info");
  }
  function deletevideo(index) {
    setvidurlListshow(false);
    setvidurlList([]);

    videosName.splice(index, 1);
    let eleLoader = document.getElementById("loader-Vid-upload");

    setvidurlList(videosName);

    eleLoader.setAttribute("class", "spinner-border text-info");

    setTimeout(() => {
      eleLoader.removeAttribute("class");

      setvidurlListshow(true);
    }, 1000);
  }
  useEffect(() => {
    // Notifications
    // api.notify.fetchNotifications(fetchAllNotifications(globalFilter)).then(res => {
    //   // setnotiList(res.data)
    //   setNotificationsList(res.data)
    // }).catch(err => console.log(err))
  }, []);
var typeArray={
    "shortDescription":"Short Description",
    "longDescription":"Long Description",
    "image":"Image",
    "video":"Video",
    "other":"Other"
};
  return (
    <>
      <div className="popup report-popup-detail  reportDetail" key={props.id}>
        <div>
          <h2 className="fs-14 theme-col fs-17 theme-col f-700"></h2>
          {!show? <h5 className="prodlisttitle"> <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Report Wrong Listing</h5>:""}
          <a className="close" onClick={() => {
            setShow(false);
            setReportType([])
            setIsReportAlready(false)
            setMultipleIssue([1])
            props.popupVisibility()}}>
            &times;
          </a>
        {!show?
          <Container className="popup-body">
            <div className="" id="cntn">
                {multipleIssue.map((item,index1)=>{
                return <>
                <div className="row mt-20">
                    <div className="col-2">Type *</div>
                    <div className="col-10">
                        <select
                        className="add_pro_form_card_input add_pro_form_inp_select w-100"
                        onChange={(e) => checkProductReport(e.target.value,index1)}
                        >
                        <option
                            selected
                            value="Type"
                            disabled
                            hidden
                            style={{ color: "red" }}
                        >
                            Select your option
                        </option>
                        {Object.entries(typeArray).map(([key, val])=>{
                            
                        return <option key={key} value={key}>{val}</option>
                        })}
                        </select>
                        {/* <button onClick={()=>removeItem(index)}>x</button> */}
                    </div>
                </div>
                 { isReportAlready ? 
                    <p className="clrRed">You have already reported on {reportData.newd}</p>
                    : 
                    
                    <div>
                        {(reportType[index1]=="longDescription" || reportType[index1]=="other") &&
                        <div className="row">
                            
                            <div className="col-12 d-flex">
                            <textarea
                                rows="4"
                                className="add_pro_form_card_input descbox"
                                placeholder={reportType[index1]=="other"?"Add your comment":"Add your comment (Description)"}
                                value={description}
                                // onKeyUp={(e) => keyDnfun(e, "longdes")}
                                onChange={(e) => {
                                    setdescription(e.target.value);
                                }}
                            />
                            </div>
                        </div>
                        }
                        {reportType[index1]=="shortDescription" &&
                        <div className="row">
                           <div className="col-12 d-flex">
                            <textarea
                                rows="4"
                                className="add_pro_form_card_input descbox"
                                placeholder="Add your comment (Short Description)"
                                value={sDescription}
                                // onKeyUp={(e) => keyDnfun(e, "longdes")}
                                onChange={(e) => {
                                    setSDescription(e.target.value);
                                }}
                            />
                            </div>
                        </div>
                        }
                        <div className="row">
                        <div className="col-2 d-flex"></div>
                            <div className="col-10 d-flex">
                                {imgprogress && (
                                    <ProgressBar
                                    id="progress-B"
                                    className="add_pro_form_progressbar"
                                    now={imgprogress}
                                    label={`${imgprogress}%`}
                                    />
                                )}
                                {/* 1 image */}
                                 {reportType[index1]=="image" && 
                                 <>
                                    <div className="add_pro_form_image_box">
                                        <div className="add_pro_form_image_cntn descbox">
                                        <label
                                            for={!imgLabelDisable ? "imgUploadImg_1" : ""}
                                            id="uploadIcon"
                                            className="add_pro_form_label flex-column"
                                        >
                                            {/* <i
                                            className="fa fa-plus-circle add_pro_form_i_nm"
                                            aria-hidden="true"
                                            ></i> */}
                                            <img src="../../../ImageAdd.png" alt="Add image" />
                                            <label className="paddingZero imgtitle">Upload Image</label>
                                        </label>
                                        {urlListshow === true &&
                                        image1 !== undefined &&
                                        image1 !== "" ? (
                                            <>
                                            <img
                                                src={
                                                "https://s3.toolsvilla.com/products/" +
                                                image1
                                                }
                                                className="add_pro_form_image_file vid-P"
                                                alt="img"
                                                id="contain-Img-Pro-1"
                                            />
                                            {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                                             <i
                                                className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                                                onClick={() => deleteImg(1, "contain-Img-Pro-1")}
                                            ></i> 
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                        
                                        </div>
                                        <label className="imgSizeNotice">(Max. size 500kb)</label>
                                        <input
                                        type="file"
                                        id="imgUploadImg_1"
                                        className="add_pro_form_uploadFile"
                                        onChange={(event) => showImage(event, "1")}
                                        onClick={(event)=> { 
                                            event.target.value = null
                                       }}
                                        accept="image/*"
                                        />
                                    </div>

                                    <div className="add_pro_form_image_box">
                                        <div className="add_pro_form_image_cntn descbox">
                                        <label
                                            for={!imgLabelDisable ? "imgUploadImg_2" : ""}
                                            id="uploadIcon"
                                            className="add_pro_form_label flex-column"
                                        >
                                            {/* <i
                                            className="fa fa-plus-circle add_pro_form_i_nm"
                                            aria-hidden="true"
                                        ></i> */}
                                            <img src="../../../ImageAdd.png" alt="Add image" />
                                        <label className="paddingZero imgtitle">Upload Image</label>
                                        </label>
                                        {urlListshow === true &&
                                        image2 !== undefined &&
                                        image2 !== "" ? (
                                            <>
                                            <img
                                                src={
                                                "https://s3.toolsvilla.com/products/" +
                                                image2
                                                }
                                                className="add_pro_form_image_file vid-P"
                                                alt="img"
                                                id="contain-Img-Pro-2"
                                            />
                                            {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                                             <i
                                                className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                                                onClick={() => deleteImg(2, "contain-Img-Pro-2")}
                                            ></i> 
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                        </div>
                                        <label className="imgSizeNotice">(Max. size 500kb)</label>
                                        <input
                                        type="file"
                                        id="imgUploadImg_2"
                                        className="add_pro_form_uploadFile"
                                        onChange={(event) => showImage(event, "2")}
                                        onClick={(event)=> { 
                                            event.target.value = null
                                       }}
                                        accept="image/*"
                                        />
                                    </div>
                                </>
                                }
                                {reportType[index1]=="video" && 
                                <div className="add_pro_form_image_box">
                                    {progress && (
                                        <ProgressBar
                                        id="progress-B"
                                        className="add_pro_form_progressbar"
                                        now={progress}
                                        label={`${progress}%`}
                                        />
                                    )}
                                    
                                    <div className="add_pro_form_image_cntn descbox">
                                        <label
                                        for="uploadFile2"
                                        id="uploadIcon"
                                        className="add_pro_form_label flex-column"
                                        >
                                        {/* <i
                                            className="fa fa-plus-circle add_pro_form_i_nm"
                                            aria-hidden="true"
                                        ></i> */}
                                        <img src="../../../video_icon.png" alt="Add image" />
                                        <label className="add_pro_form_labels_inf paddingZero imgtitle">Upload video</label>
                                        </label>
                                        {vidurlListshow === true ? (
                                        vidurlList.map((item, index) => {
                                            return (
                                            <>
                                                <video
                                                src={
                                                    "https://media.toolsvilla.com/" +
                                                    item
                                                }
                                                className="add_pro_form_video_file vid-P"
                                                onClick={() =>
                                                    playVideo(
                                                    "https://media.toolsvilla.com/" +
                                                        item
                                                    )
                                                }
                                                key={index}
                                                alt="img"
                                                id="loader-Vid-upload"
                                                />
                                                 <i
                                                className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn"
                                                onClick={() => deletevideo(index)}
                                                ></i> 
                                                <i
                                                className="fa fa-play ms-2 play-tag-vid add_pro_form_med_play_btn"
                                                aria-hidden="true"
                                                onClick={() =>
                                                    playVideo(
                                                    "https://media.toolsvilla.com/" +
                                                        item
                                                    )
                                                }
                                                ></i>
                                            </>
                                            );
                                        })
                                        ) : (
                                        <></>
                                        )}
                                    </div>
                                    

                                    
                                    <label className="imgSizeNotice">(Max. size 15mb)</label>
                                    <input
                                        type="file"
                                        id="uploadFile2"
                                        className="add_pro_form_uploadFile"
                                        onChange={(event) => showVideo(event)}
                                        onClick={(event)=> { 
                                            event.target.value = null
                                       }}
                                        accept="video/*"
                                    />
                                </div>
                                    
                                }
                            </div>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-2"></div>
                    <div className="col-10">
                        {reportType[index1]=="video"?<p className="reportNote">Note: You can upload only one video</p>:""}
                        {reportType[index1]=="image"?<p className="reportNote">Note: You can upload only two images</p>:""}
                    </div>
                </div>
                </>
                })}
                { isReportAlready ? "":
                <>
                
                {reportType.length>0?
                 
                    <div type="button"  className="v-t-f text-center addissue" value="click" onClick={()=>setMultipleIssue(pi=>[...pi,1])}>Report More Issue +</div>:""}
                    <div className="row">
                    <div className="add_pro_form_fin_btns submitBtn">
                            <button onClick={() => AddProductReport()}>Submit</button>
                        </div>
                    </div>
                    </>

                        }
                {/* } */}
            </div>
            {/* { notificationsList && notificationsList.map((item, index) => {
              let date = new Date(item.createdAt);
              date = date.toUTCString(item.createdAt);
              date = date.substr(4, 12);

              let cmb = "";
              if (item.productDetails && item.productDetails.value) {
                item.productDetails.value.map((litem, lindex) => {
                  cmb = cmb + litem;
                  if (lindex !== item.productDetails.value.length - 1) {
                      cmb = cmb + " x "
                  }
                })
              }

              return (
              <Row>
                <div className="col-2">
                { item.productDetails && item.productDetails.images && item.productDetails.images.map((img, index) => {
                  if (img.baseImage) {
                    return (
                      <img className='vid_tuts_logo prdImg' 
                      src={ "https://s3.toolsvilla.com/" + img.image } 
                      alt="base image" />
                    )
                  }
                  })
                }
                </div>
                <div className="col-10">
                  <h6>{item.productDetails && item.productDetails.productName}</h6>

                  { item.productDetails && item.productDetails.url && (
                    <span className={item.opened? "enq-card-comb-span m-1 combDtl bgGray": "enq-card-comb-span m-1 combDtl"} role="button" key={index} onClick={() => window.open(`/productDetConf/${item.product}?url=${item.productDetails.url}`, '_blank')}>
                      <span className="ff_pop">{cmb}</span>
                    </span>
                  )}

                  <p>{item.notes}</p>
                  { item.productDetails && !item.productDetails.url ? (
                    <div>
                    {
                      item.type == "PRC_CHANGED"?
                      <button className={item.opened? "invent_pro_v_t_f_btn activeBtn bgGray": "invent_pro_v_t_f_btn activeBtn"} onClick={() => window.open(`/productDetail/${item.product}/approv`, "_blank")}>Verify Transfer Price</button> :
                      item.type == "WEIGHT_CHANGED"?
                      <button className={item.opened? "invent_pro_v_t_f_btn activeBtn bgGray": "invent_pro_v_t_f_btn activeBtn"} onClick={() => window.open(`/productDetail/${item.product}/approv`, "_blank")}>Verify Weight</button> :
                      <button className={item.opened? "invent_pro_v_t_f_btn activeBtn bgGray": "invent_pro_v_t_f_btn activeBtn"} onClick={() => window.open(`/my-inventory/new_product_request/action_req`, "_blank")}>Approve Request</button>
                    } 
                  </div> ) : ( <div>
                    {
                      item.type == "PRC_CHANGED"?
                      <button className={item.opened? "invent_pro_v_t_f_btn activeBtn bgGray": "invent_pro_v_t_f_btn activeBtn"} onClick={() => window.open(`/productDetConf/${item.product}?url=${item.productDetails.url}`, '_blank')}>Verify Transfer Price</button> :
                      item.type == "WEIGHT_CHANGED"?
                      <button className={item.opened? "invent_pro_v_t_f_btn activeBtn bgGray": "invent_pro_v_t_f_btn activeBtn"} onClick={() => window.open(`/productDetConf/${item.product}?url=${item.productDetails.url}`, '_blank')}>Verify Weight</button> :
                      <button className={item.opened? "invent_pro_v_t_f_btn activeBtn bgGray": "invent_pro_v_t_f_btn activeBtn"} onClick={() => window.open(`/my-inventory/new_product_request/action_req`, "_blank")}>Approve Request</button>
                    } 
                    </div>
                  ) }

                  <span className="date">{date}</span>
                </div>
              </Row>
              )
            }) 
            } */}
          </Container>
          :
          <div className="issuemesage">
                <div className="heading">We have received your request.</div>
               <div className="msg"> If we accept your recommendations, the changes will be reflected within 24 hours.
                </div>
            </div>
      }
        </div>
      </div>
      
    </>
  );
}

export default PopupProductReport;